import { AuthUser, ExposedUser } from './constants';

const NO_USER = null;

const validUser = (contextUser: AuthUser | null): ExposedUser => {
  if (!contextUser || (contextUser.exp && (Date.now()/1000 > contextUser.exp))) {
    return NO_USER;
  }
  return contextUser;
};

export default validUser;